
'use strict';

const React = require( 'react' );
const request = require( 'superagent' );
const Helpers = require( '../../../../../_plugins/lib/helpers' );
const GoogleMap = require( './googleMap.jsx' );
const DirectionRoute = require( './directionRoute.jsx' );
const { Marker } = require( 'react-google-maps' );
const { DirectionsRenderer } = require( 'react-google-maps' );
const propTypes = require('prop-types');

const { object, string, array } = propTypes;

let previousInfoWindowContent = { };
let bounds;
const createReactClass = require('create-react-class');

const Map = createReactClass({
  mixins: [ Helpers ],

  propTypes: {
    id: string,
    functionParams: array,
    pageData: object,
    settings: object.isRequired,
    domainSettings: object
  },

  shouldComponentUpdate( nextProps, nextState ) {
    if ( nextState.markers !== this.state.markers ) return true;
    if ( nextState.infoWindowObject !== this.state.infoWindowObject ) return true;
    if ( nextState.directions !== this.state.directions ) return true;
    return false;
  },

  buildMap( ) {
    const { pageData: { productClass }, settings, domainSettings, functionParams } = this.props;
    let url = domainSettings.scheme + ':' + settings.soapiBase + settings.locationTableRoute;
    url += '&site_code=' + domainSettings.siteCode + '&type=' + productClass + '&location=' + functionParams[0];
    request.get( url ).end( this.getResponse );
  },

  getInitialState( ) {
    return {
      markers: [ ],
      infoWindowObject: { },
      directions: null
    };
  },

  resetTheMap( ) {
    this.setState({
      infoWindowObject: {},
      directions: null
    });
  },

  getResponse( err, res ) {
    if ( err ) return;
    if ( !res || res.status === 404 || !res.body ) return;
    this.sortResponse( res.body );
  },

  sortResponse( data ) {
    const newMarkers = [ ];
    Object.keys( data ).map( key => {
      const item = data[key];
      newMarkers.push( item );
    } );
    this.createNewMarkers( newMarkers.sort( ( a, b ) => {
      if ( !a.price && b.price ) return -1;
      if ( a.price && !b.price ) return 1;
      if ( !a.price && !b.price ) return 0;
      return a.price.per_week - b.price.per_week;
    }));
    //Reset the map one search criteria changes
    this.resetTheMap( );
  },

  hideInfoWindow( ) {
    this.setState({ infoWindowObject: { } });
  },

  createNewMarkers( data ) {
    const { settings } = this.props;
    bounds = new window.google.maps.LatLngBounds( );
    const markers = data.reduce( ( mapPins, item ) => {
      if ( !item.prodlib.name || item.prodlib.name.match( /Mystery/ ) ) return mapPins;
      if ( !item.prodlib.latitude || !item.prodlib.longitude ) return mapPins;
      const latLon = new window.google.maps.LatLng( item.prodlib.latitude, item.prodlib.longitude );
      bounds.extend( latLon );
      const marker = {
        position: latLon,
        price: ( item.price ? settings.priceFormat + item.price.per_week : 'Search for price' ),
        info: item,
        key: item.code
      };
      mapPins.push( marker );
      return mapPins;
    }, [ ] );

    const customMarkers = this.insertMarkers( markers );

    this.setState({
      markers,
      customMarkers
    });

    setTimeout( ( ) => {
      google.maps.event.addListener( this.$( '#theMap'), 'resize', ( ) => { // eslint-disable-line no-undef
        this._googleMapComponent.fitBounds( bounds );
      });
      this._googleMapComponent.fitBounds( bounds );
    }, 1000);
  },

  drawDirections( marker, event ) {
    event.preventDefault();
    const DirectionsService = new google.maps.DirectionsService( ); // eslint-disable-line no-undef
    DirectionsService.route({
      origin: this._directionInput.value,
      destination: marker.position,
      travelMode: google.maps.TravelMode.DRIVING // eslint-disable-line no-undef
    }, ( result, status ) => {
      if ( status === google.maps.DirectionsStatus.OK ) { // eslint-disable-line no-undef
        this.setState({
          directions: result,
          infoWindowObject: {}
        });
      }
    });
  },

  showInfoWindow( marker ) {
    const { prodlib: { name, address }, score, pagename } = marker.info;
    const infoWindowMarkup = (
      <div id="infoWindowContent">
        <h3 className="infoWindowH2"><a href={ pagename }>{ name }</a></h3>
        <p className="hx-distance-time-to-terminal" dangerouslySetInnerHTML={{ __html: address }} />
        <form onSubmit={ this.drawDirections.bind( this, marker ) }>
          Directions
          <div className="input-group">
            <input style={{ width: '100px' }} type="text" ref={ ( directions ) => ( this._directionInput = directions ) } defaultValue="" className="form-control" placeholder="Search..." />
            <button style={{ padding: '10px 15px', borderRadius: '0 3px 3px 0', borderLeft: '0' }} type="submit" name="type" className="btn btn-default">
              <i className="fa fa-search" />
            </button>
          </div>
        </form>
        { score && score.count && (
          <div>
            <hr />
            <p className="hx-ratings"><strong>Rating: </strong>{ score.average + ' / 5 ' } ( { score.reviewed + ' reviews' } )</p>
          </div>
        ) }
      </div>
    );
    const infoWindowObject = {
      onCloseclick: this.hideInfoWindow,
      position: marker.position,
      content: infoWindowMarkup
    };
    previousInfoWindowContent = infoWindowObject;
    this.hideInfoWindow( );
    setTimeout( ( ) => {
      this.setState({
        infoWindowObject,
        directions: null
      });
    }, 250 );
  },

  insertMarkers( markers ) {
    return markers.reduce( ( allMarkers, marker ) => {
      const { key, position } = marker;
      allMarkers.push(
        <Marker
          key={ 'pin_' + key + Date.now( ) }
          position={ position }
          onClick={ this.showInfoWindow.bind( this, marker ) }
        />
      );
      return allMarkers;
    }, [ ] );
  },

  /*This is pretty hacky, it styles the individual divs that come back from google api for the info window.
  It is styled this way as we dont have access to the containing divs in css*/
  styleTheInfoWindowsParent( infoWindow ) {
    const parent = this.getParentNode( infoWindow, 2 );
    const infoWindowWidth = 347;
    parent.style.width = infoWindowWidth + 2;
  },

  hackInfoWindowStyles( ) {
    const self = this;
    const interval = setInterval( ( ) => {
      if ( self.$( '.gm-style-iw' ) === null ) return;
      clearInterval( interval );
      self.styleTheInfoWindowsParent( self.$( '.gm-style-iw' ) );
    }, 20 );
  },

  showPreviousInfoWindow( ) {
    this.setState( {
      infoWindowObject: previousInfoWindowContent,
      directions: null
    } );
  },

  handleMapClick( ) {
    $( 'html, body' ).animate( {
      scrollTop: $( '#theMap' ).offset( ).top - 50
    }, 500);
  },

  attachMap( map ) {
    const { markers } = this.state;
    if ( !map || markers.length ) return;
    this._googleMapComponent = map;
    this.buildMap( );
  },

  render( ) {
    const { id } = this.props;
    const { infoWindowObject, directions, customMarkers } = this.state;
    if ( infoWindowObject && infoWindowObject.content ) this.hackInfoWindowStyles( );
    const mapDirections = directions ? <DirectionsRenderer directions={ directions } /> : null;
    return (
      <div id={ id }>
        <GoogleMap
          defaultZoom={ 10 }
          options={{ clickableIcons: false }}
          mapRef={ this.attachMap }
          markers={ customMarkers }
          infoWindow={ infoWindowObject }
          mapDirections={ mapDirections }
          click={ this.handleMapClick }
        />
      { directions && (
        <DirectionRoute directions={ directions.routes[0].legs[0] } />
      )}
      </div>
    );
  }
});

module.exports = Map;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/map/map.jsx